import React, { /*useState, useEffect*/ } from 'react'

// Deps
// import { redirect } from 'controllers/navigator'

// Partials
import Loader from 'views/shared/pages/loader'

// Utils
// import { openModal } from 'utils/modals';

// const checkStatusMessage = (search, orderCode) => {

//     let returnStatus = false;
//     let splitSearch = search.split('=');
//     if (splitSearch[0] === '?status' && splitSearch.length > 1) {
//         returnStatus = splitSearch[1];
//     }

//     return returnStatus;
// }

const PaymentHandler = (props) => {
    // const source = props.match.params.source;
    // const orderID = props.match.params.orderID;

    // const [status] = useState(checkStatusMessage(props.location.search));

    // useEffect(() => {
    //     if(source === 'expressorder') {
    //         if(status === 'success') {
    //             openModal('message', {
    //                 message: 'Hızlı ödemeniz başarıyla gerçekleşti.',
    //                 top: true,
    //             });
    //             redirect({to: 'orderDetail', type: 'replace'}, { id: orderID });
    //         }
    //         else {
    //             openModal('create-express-order');
    //             openModal('message', {
    //                 message: 'Ödeme başarısız oldu. Lütfen bilgilerinizi kontrol ederek tekrar deneyin.',
    //                 top: true,
    //             });

    //             redirect({ to: 'dashboard', type: 'replace'});
    //         }
    //     }
    // }, [source, orderID, status])
    return <Loader />
}

export default PaymentHandler;